import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import NoStyleButton from "components/Library/NoStyleButton";
import Icon from "components/Library/Icon";

import styles from "./SaveButton.css";

export default function SaveButton({ saved, onClick }) {
  return (
    <NoStyleButton
      onClick={onClick}
      trackingClassName="gtm-save-story"
      className={classNames(styles.root, { [styles.saved]: saved })}
    >
      <span className={styles.text}>{saved ? "Saved" : "Save"}</span>
      <Icon
        name="save"
        description={saved ? "Unsave story" : "Save story"}
        className={styles.icon}
      />
    </NoStyleButton>
  );
}

SaveButton.propTypes = {
  saved: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};
